import React from 'react';
import './Abanner.css';

const Abanner = () => {
    return (
        <div id="header2">
            <div id="allcar">
                <h1 id="h1" > <span id="span">All New BMW</span> </h1>
                <p id="p"><span id="span"> Meet The Best !</span></p>
            </div>
        </div>
    );
};

export default Abanner;